import {
  Cookie as CookieClient,
  createRealTimeCookie,
} from "@cookie-baker/browser";
import { reatomCookie } from "@reatom/npm-cookie-baker";

type utmCookieModel = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
};

const cookie = new CookieClient<utmCookieModel>();
const realTimeCookie = createRealTimeCookie(cookie);

export const utmAtom = reatomCookie(cookie, realTimeCookie);
